<div
  #box
  [ngClass]="classes"
  [attr.role]="showInfo ? 'note' : 'checkbox'"
  (click)="onCheckboxChange()"
  (keyup.Space)="onCheckboxChange()"
>
  <span *ngIf="showInfo">{{ !!formControlName ? value.info : info }}</span>
</div>
<input
  #input
  *ngIf="!!formControlName"
  type="text"
  #model="ngModel"
  [(ngModel)]="value"
  style="display: none"
  [name]="name"
  [id]="name"
  [disabled]="userFacadeService.isReadOnly() && !ignoreReadOnly"
/>
